export default __webpack_public_path__ + "static/emprevel-35ad6b258e8e953857133e09224e0868.jpg";